import { useState } from 'react';

import PlusGIF from '@/assets/header/plus.gif';

import FormModal from '@/components/Modals/Invite/FormModal';

const InviteButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div
        className="flex justify-center items-center mr-5 gap-1 mt-[16px] cursor-pointer"
        onClick={() => setIsOpen(true)}>
        <img src={PlusGIF} alt="plus" className="w-[26px] h-[26px]" />
        <a className="font-jostMedium underline">Inviter en kollega</a>
      </div>

      <FormModal isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default InviteButton;
